import {
  ADD_TO_CART_BEGIN,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_FAILURE,
  GET_CARTS_BEGIN,
  GET_CARTS_SUCCESS,
  GET_CARTS_FAILURE,
  CREATE_CART_BEGIN,
  CREATE_CART_SUCCESS,
  CREATE_CART_FAILURE,
  DELETE_CART_ENTRY_BEGIN,
  DELETE_CART_ENTRY_FAILURE,
  DELETE_CART_ENTRY_SUCCESS,
} from "../actions/customerActions";
import config from "../environment/environment-config";

const initialState = {
  carts: config.cartConfig?.carts ?? [],
  loading: false,
  errors: null,
};

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_TO_CART_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: null,
      };
    case ADD_TO_CART_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errorDetails,
      };
    case GET_CARTS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_CARTS_SUCCESS:
      return {
        ...state,
        loading: false,
        carts: action.payload.cartsResponse.carts,
        errors: null,
      };
    case GET_CARTS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errorDetails,
      };
    case CREATE_CART_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CART_SUCCESS:
      return {
        ...state,
        carts: [...state.carts, action.payload.cart],
        loading: false,
      };
    case CREATE_CART_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errorDetails,
      };

    case DELETE_CART_ENTRY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_CART_ENTRY_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errorDetails,
      };

    case DELETE_CART_ENTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: null,
      };

    default:
      return state;
  }
}
